import React, { useContext, useEffect, useState } from "react";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import AlertContext from "../../../../Context/Alert/AlertContext";
import axios from "axios";
import { BaseURL } from "../../../../Files/BaseURL";
import ThemeContext from "../../../../Context/theme/ThemeContext";

const OfferOverview = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { theme } = useContext(ThemeContext);

  const [Users, setUsers] = useState([]);

  const [loading, setLoading] = useState(false);

  const alertcontext = useContext(AlertContext);
  const { showAlert } = alertcontext;

  const [OfferDetailsData, setOfferDetailsData] = useState({
    Type: "",
    Title: "",
    Price: "",
    Delivery: "",
    Description: "",
    Buyers: [],
    files: [],
  });
  const [isUserFetchSuccess, setIsUserFetchSuccess] = useState(false);

  const fetchusers = async (Emails) => {
    const auth = localStorage.getItem('p@token');
    try {
      const response = await axios.patch(
        `${BaseURL}/api/offer/getuserbyemails`,
        { Emails: Emails },

        {
          headers: {
            'auth-token': auth
          }
        }

      );

      if (response.data.success) {
        setUsers(response.data.users);
        setIsUserFetchSuccess(true);
      } else {
        showAlert(response.data.message, "danger");
        setIsUserFetchSuccess(false);
        return;
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        // showAlert(error.response.data.message, "danger");
        setIsUserFetchSuccess(false);
        return;
      } else {
        showAlert("Internal Server Error", "danger");
        setIsUserFetchSuccess(false);
        return;
      }
    }
  };

  useEffect(() => {
    const { OfferDetailsData: OfferDetailsData } = location.state || {};
    setOfferDetailsData(OfferDetailsData);
    fetchusers(OfferDetailsData?.Buyers);
  }, []);

  const handleSubmit = async () => {
    if (!isUserFetchSuccess) {
      showAlert("You caanot create the job offer to itself", "danger");
      return;
    }
    try {
      setLoading(true);
      if (!OfferDetailsData.Type) {
        showAlert("Offer type is required", "danger");
        return;
      }
      const formData = new FormData();
      formData.append("Type", OfferDetailsData.Type);
      formData.append("Title", OfferDetailsData.Title);
      formData.append("Price", OfferDetailsData.Price);
      formData.append("Delivery", OfferDetailsData.Delivery);
      formData.append("Description", OfferDetailsData.Description);
      formData.append("Buyers", JSON.stringify(OfferDetailsData.Buyers));

      if (OfferDetailsData.files && OfferDetailsData.files.length > 0) {
        OfferDetailsData.files.forEach((file) => {
          formData.append("files", file);
        });
      }

      const authToken = localStorage.getItem("p@token");
      const response = await axios.post(
        `${BaseURL}/api/offer/offercreation`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "auth-token": authToken,
          },
        }
      );

      if (response.data.success) {
        showAlert("Offer created successfully", "success");
        navigate("/user-dashboard/offer_success");
      } else {
        throw new Error(response.data.message || "Failed to create offer");
      }
    } catch (error) {
      console.error("Error creating offer:", error);
      showAlert(error.message || "Error creating offer", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center font-pop flex-col">
      <div
        className={`rounded-2xl py-6 px-6 my-6 w-[95%] md:w-[70%] xl:w-[47%] flex flex-col gap-4 
              ${theme === "dark" ? "bg-black text-white" : "bg-white"}`}
      >
        <h1 className="font-semibold text-2xl">Create offer</h1>
        <p
          className={` text-lightGrey font-pop ${theme === "dark" && "text-white"
            }`}
        >
          Checking info
        </p>
        <div className="flex flex-col gap-4">
          <div className="border-2 font-pop flex truncate flex-col gap-4 border-[#E9E9E9] w-full rounded-2xl py-4 px-4">
            <div className="flex gap-2 items-center truncate">
              <h2
                className={` text-lightGrey ${theme === "dark" && "text-white"
                  }`}
              >
                Deadline
              </h2>
              <p className="font-medium">{OfferDetailsData?.Delivery}</p>
            </div>
            <div className="flex justify-between">
              <div className="flex flex-col gap-2">
                <h2 className="text-2xl font-semibold">
                  {OfferDetailsData?.Title}
                </h2>
              </div>
              <div className="flex flex-col gap-2">
                <p className="font-medium text-primarygreen">
                  ${OfferDetailsData?.Price}
                </p>
              </div>
            </div>
            <p className="font-medium">{OfferDetailsData?.Type}</p>
          </div>
          <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-2 rounded-2xl py-4 px-4">
            <p
              className={`text-lg text-gray-400  ${theme === "dark" && "text-white"
                }`}
            >
              Description
            </p>
            <h2 className="text-lg font-medium truncate">
              {OfferDetailsData?.Description}
            </h2>
          </div>
          <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
            <p
              className={`text-lg text-gray-400  ${theme === "dark" && "text-white"
                }`}
            >
              Buyer
            </p>
            <div className="flex flex-col gap-2">
              {Users?.map((item, index) => (
                <div className="flex flex-row gap-2 items-center" key={index}>
                  {item?.ProfilePhoto ? (
                    <img
                      src={item?.ProfilePhoto}
                      alt=""
                      className="rounded-full w-8 md:w-12 h-8 md:h-12"
                    />
                  ) : (
                    <div className="w-8 md:w-12 h-8 md:h-12 rounded-full font-pop bg-gray-400 flex items-center justify-center">
                      <span className="text-white">
                        {item && item?.FirstName?.charAt(0)}
                      </span>
                    </div>
                  )}
                  <h2 className="font-semibold">
                    {item?.FirstName} {item?.LastName}
                  </h2>
                </div>
              ))}
            </div>
          </div>
          <div className="border-2 border-[#E9E9E9] w-full flex flex-col gap-4 rounded-2xl py-4 px-4">
            <p
              className={`text-lg text-gray-400  ${theme === "dark" && "text-white"
                }`}
            >
              Attached files
            </p>
            {OfferDetailsData?.files?.map((item, index) => (
              <div className="flex flex-row gap-2 items-center">
                <img
                  src="../../Assets/Prop/pdf.png"
                  alt=""
                  className="w-8 h-8"
                />
                <h2 className="font-semibold">{item.name}</h2>
              </div>
            ))}
          </div>

          <button
            className={`my-4 px-2 md:px-6 bg-green-500 hover:bg-transparent  hover:bg-white-500 font-medium hover:text-black font-pop text-sm md:text-lg py-2 md:py-3 border border-black-500 hover:border-green-500 rounded-full  text-white  *: ${theme === "dark" ? "hover:text-white" : " hover:text-black"
              }`}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Creating Offer..." : "Create offer"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferOverview;
